import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import Img1 from "../images/no-messages.png"
import DefaultAvatar from "../images/default_avatar.jpg"
import SendMessage from './SendMessage'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { clearConversationAction, getPrivateConversationsAction, singleConversationsAction } from '../../redux/actions/chatActions'
import { useSearchParams } from 'react-router-dom';

import SingleMessage from './SingleMessage/SingleMessage'
import { formatDbDate } from '../../utils/dateFormater'
import Loader from "../loader/loader"
import { CLEAR_CONVERSATION_RESET } from '../../redux/constants/chatConstants'
import { socket } from "../../utils/socket.js"
import MessageAlert from './MessageAlert.jsx'
import notificationSound from "../images/audio.mp3";

dayjs.extend(relativeTime);



const MessengerBox = ({ newUserData, conversationID, setNewUserData, setConversationID }) => {



    const dispatch = useDispatch()





    const [searchParams, setSearchParams] = useSearchParams();
    const [showDeleteButton, setShowDeleteButton] = useState(false)
    const [alertData, setAlertData] = useState([])
    const [onlineUsers, setOnlineUsers] = useState([])



    const messagesEndRef = useRef(null);
    const audioRef = useRef(null);


    const { loading, message: msg, conversation_id } = useSelector(state => state.sendPrivateMessage)
    const { loading: clearConversationLoading, message: clearMessage } = useSelector(state => state.clearConversation)
    const {

        conversation,
        other_user,
        messages
    } = useSelector(state => state.conversation)



    useEffect(() => {

        if (conversationID) {

            dispatch(singleConversationsAction(conversationID))
            dispatch(getPrivateConversationsAction({ perPage: 50 }))

        }

    }, [conversationID, dispatch, msg])



    useEffect(() => {
        audioRef.current = new Audio(notificationSound);
    }, []);

    useEffect(() => {
        socket.emit("get_online_users");

        socket.on("online_users", (data) => {
            setOnlineUsers(data);
        });

        return () => {
            socket.off("online_users");
        };
    }, []);



    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView();
    };

    useEffect(() => {
        if (messages?.length > 0) {
            scrollToBottom();
        }
    }, [messages, msg]); // msg = new message trigger



    const lastSeenMessageIndex = useMemo(() => {
        if (!other_user?.last_read_at || !messages?.length) return -1;

        return messages
            .map((msg, i) => ({ msg, i }))
            .filter(item =>
                item.msg.message_sender === "me" &&
                new Date(item.msg.created_at) <= new Date(other_user.last_read_at)
            )
            .pop()?.i ?? -1;

    }, [messages, other_user]);


    const handleClearChat = () => {

        dispatch(clearConversationAction({ conversation_id: conversationID }))

    }




    useEffect(() => {
        if (clearMessage) {
            dispatch(singleConversationsAction(conversationID))
            dispatch(getPrivateConversationsAction({ perPage: 50 }))
            setShowDeleteButton(false)
            dispatch({ type: CLEAR_CONVERSATION_RESET })
        }
    }, [clearMessage, dispatch, conversationID])




    useEffect(() => {
        if (conversation_id && Object.keys(newUserData).length > 0 && msg) {
            setConversationID(conversation_id)
            setNewUserData({})

        }
    }, [conversation_id, setConversationID, setNewUserData, newUserData, msg])







    useEffect(() => {
        const handleNewMessage = (data) => {
            setAlertData(prev => [...prev, data])




            // 🔊 Play sound
            if (audioRef.current) {
                audioRef.current.currentTime = 0; // restart if already playing
                audioRef.current.play().catch(err => {
                    console.log("Audio play blocked:", err);
                });
            }


            dispatch(getPrivateConversationsAction({ perPage: 50 }))





            if (conversationID) {
                dispatch(singleConversationsAction(conversationID))
            }



        };

        socket.on("new_message", handleNewMessage);

        return () => {
            socket.off("new_message", handleNewMessage);
        };
    }, [dispatch, conversationID]);




    useEffect(() => {

        setConversationID(searchParams.get("conversation_id") || "")

    }, [searchParams,setConversationID])

    useEffect(() => {

        const query = {}

        
        if (conversationID) {
            query.conversation_id = conversationID
        }



        setSearchParams(query)
    }, [conversationID, setSearchParams])

    return (
        <Fragment>
            {clearConversationLoading && <Loader />}
            <div className="flex flex-col h-full relative">
                {Object.keys(newUserData).length > 0 || (other_user && Object.keys(other_user).length > 0) ? (
                    <>
                        {/* Header */}
                        <div className="bg-white py-[1vmax] px-[1.5vmax] border-b border-gray-100 flex justify-between items-center flex-shrink-0">
                            <div className="flex gap-[1vmax] items-center">
                                {/* Back Button (Mobile Only) */}
                                <button 
                                    className="lg:hidden text-gray-500 hover:text-gray-700 mr-[0.5vmax]"
                                    onClick={() => { setConversationID(null); setNewUserData({}); }}
                                >
                                    <i className="fa-solid fa-arrow-left text-[1.2vmax]"></i>
                                </button>
                                
                                <div className="w-[3vmax] h-[3vmax] rounded-full overflow-hidden border border-gray-100 shadow-sm">
                                    <img src={newUserData?.avatar_url || other_user?.avatar_url || DefaultAvatar} alt="Avatar" className="w-full h-full object-cover" />
                                </div>
                                <div>
                                    <div className="flex items-center gap-[0.5vmax]">
                                        <h3 className='text-[1.1vmax] font-bold text-gray-800'>{newUserData?.name || other_user?.name}</h3>
                                        {(newUserData?.role || other_user?.role) && (
                                            <span className="text-[0.65vmax] font-bold px-[0.5vmax] py-[0.1vmax] rounded-full bg-indigo-50 text-indigo-600 uppercase">
                                                {newUserData?.role || other_user?.role}
                                            </span>
                                        )}
                                    </div>
                                    <div className="flex items-center gap-1 mt-[0.1vmax]">
                                        <div className={`w-[0.5vmax] h-[0.5vmax] rounded-full ${onlineUsers.includes(String(newUserData?.id || other_user?.id)) ? "bg-emerald-500" : "bg-gray-400"}`}></div>
                                        <p className='text-[0.75vmax] text-gray-500 font-medium'>
                                            {onlineUsers.includes(String(newUserData?.id || other_user?.id)) 
                                                ? "Online" 
                                                : other_user?.last_seen 
                                                    ? `Last seen ${dayjs(other_user.last_seen).fromNow()}` 
                                                    : "Offline"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="relative">
                                <button 
                                    className="w-[2.5vmax] h-[2.5vmax] bg-gray-50 text-gray-500 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors"
                                    onClick={() => setShowDeleteButton(!showDeleteButton)}
                                >
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                </button>
                                {showDeleteButton && (
                                    <button 
                                        className="absolute top-[3vmax] right-0 bg-white border border-gray-100 shadow-lg rounded-lg p-[0.5vmax_1vmax] text-[0.85vmax] font-bold text-rose-600 hover:bg-rose-50 transition-colors whitespace-nowrap z-10"
                                        onClick={handleClearChat}
                                        disabled={clearConversationLoading}
                                    >
                                        <i className="fa-regular fa-trash-can mr-1"></i> Delete Chat
                                    </button>
                                )}
                            </div>
                        </div>

                        {/* Messages Area */}
                        <div className="h-[55vh] overflow-y-auto my-scroll p-[1.5vmax] flex flex-col gap-[1vmax] bg-gray-50/30">
                            {conversation && Object.keys(newUserData).length === 0 && (
                                <div className='flex items-center gap-[1vmax] justify-center my-[1.5vmax] w-full'>
                                    <div className="flex-1 h-[1px] bg-gray-100"></div>
                                    <span className='text-gray-400 text-[0.8vmax] font-medium'>
                                        Conversation Started at {formatDbDate(conversation?.created_at)}
                                    </span>
                                    <div className="flex-1 h-[1px] bg-gray-100"></div>
                                </div>
                            )}

                            {messages?.length > 0 && Object.keys(newUserData).length === 0 ? (
                                messages.map((message, index) => (
                                    <SingleMessage
                                        key={message?.id}
                                        message={message}
                                        index={index}
                                        other_user={other_user}
                                        lastSeenMessageIndex={lastSeenMessageIndex}
                                    />
                                ))
                            ) : (
                                !loading && Object.keys(newUserData).length > 0 && (
                                    <div className="flex flex-col items-center justify-center flex-1 text-gray-400 gap-[0.5vmax]">
                                        <i className="fa-regular fa-comments text-[3vmax]"></i>
                                        <p className="text-[1vmax] font-medium">Start a new conversation</p>
                                    </div>
                                )
                            )}
                            <div ref={messagesEndRef} />

                            {loading && (
                                <div className="w-[2vmax] h-[2vmax] border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin mx-auto my-[2vmax]" />
                            )}
                        </div>

                        {/* Send Message Area */}
                        <div className="border-t border-gray-100 p-[1.5vmax] bg-white flex-shrink-0">
                            <SendMessage user={Object.keys(newUserData).length > 0 ? newUserData : other_user} />
                        </div>
                    </>
                ) : (
                    <div className="flex flex-col items-center justify-center flex-1 bg-gray-50/50 gap-[1vmax]">
                        <img src={Img1} alt="No messages" className='w-[40%] opacity-75' />
                        <p className="text-[1.1vmax] font-bold text-gray-500">Select a chat to start messaging</p>
                    </div>
                )}
            </div>

            {/* Alerts */}
            {alertData?.map((alertVal, index) => (
                <MessageAlert
                    key={alertVal.conversation_id || index}
                    alertVal={alertVal}
                    removeAlert={() => {
                        setAlertData(prev =>
                            prev.filter(item => item !== alertVal)
                        )
                    }}
                />
            ))}
        </Fragment>
    )
}

export default MessengerBox
